import { environment } from '../../../environments/environment';
import { Denounce, Status } from './../models/denounce.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

interface DashboardReq {
	bus_name?: string;
	occurence?: string;
	type?: string;
	gender?: string;
	place_complaint?: string;
	sublocality_complaint?: string;
	user_id_complaint?: string;
	created_at_from_date_complaint?: any;
	created_at_to_date_complaint?: any;
	age?: string;
}

interface ComplaintsReq {
	paginate?: boolean;
	details?: boolean;
	bus_name?: string;
	occurence?: string;
	type?: string;
	occurence_date?: string;
	place_complaint?: string;
	sublocality_complaint?: string;
	user_id_complaint?: string;
	created_at_from_date_complaint?: any;
	created_at_to_date_complaint?: any;
	atMoment?: boolean;
	orderBy?: string[];
	gender?: string;
	age?: string;
}

@Injectable({
	providedIn: 'root',
})
export class ComplaintsService {
	constructor(
		private http: HttpClient,
		private toastr: ToastrService,
		private authService: AuthService,
		private notificationService: NotificationService
	) {}

	/**
	 * Create the request for upload an image
	 * @param url url to send the request
	 * @param body body of the request
	 * @param fields fields of image for append in body
	 * @param file file that will be sent
	 * @returns request to upload image
	 */

	audio = new Audio();
	playAudio() {
		this.audio.src = 'assets/sounds/alert.wav';
		this.audio.load();
		this.audio.play();
	}

	private formatDate(date) {
		let day = date.getDate();
		let month = date.getMonth() + 1; // Months are 0 based
		let year = date.getFullYear().toString().substr(-2); // Get last two digits of year
		let hours = date.getHours();
		let minutes = date.getMinutes();

		// Pad single digit day, month, hours and minutes with leading zero
		day = day < 10 ? '0' + day : day;
		month = month < 10 ? '0' + month : month;
		hours = hours < 10 ? '0' + hours : hours;
		minutes = minutes < 10 ? '0' + minutes : minutes;

		return `${hours}h${minutes} ${day}/${month}/${year}`;
	}

	public setEmergencyListener(): void {
		let lastComplaints = [];
		let emergencies = [];

		this.getComplaints().subscribe((data) => {
			lastComplaints = data.complaints;

			setInterval(() => {
				if (this.authService.isAuthenticated) {
					this.getComplaints().subscribe((data) => {
						const complaints = data.complaints;

						for (let complaint in complaints) {
							const index = lastComplaints.findIndex(
								(element) => element._id == complaints[complaint]._id
							);

							if (index == -1) {
								const newComplaint = complaints[complaint];

								const complaintDate = this.formatDate(
									new Date(newComplaint.datetime)
								);

								const complaintDescription = `${complaintDate} | ${newComplaint.place} | ${newComplaint.sublocality}, ${newComplaint.city_name}-${newComplaint.state}`;

								this.notificationService.addNotification({
									date: new Date(),
									description: complaintDescription,
									id: newComplaint._id,
								});
							}
						}

						lastComplaints = complaints;
					});

					this.getEmergencies('ALL', true).subscribe((data) => {
						const complaints = data.complaints;

						let count = 0;
						for (let complaint in complaints) {
							const index = emergencies.findIndex(
								(element) => element._id == complaints[complaint]._id
							);

							if (index == -1) {
								count++;
							}
						}

						if (count == 1) {
							this.toastr.error(`Foi recebida uma nova emergência!`, '', {
								timeOut: 7000,
							});
							this.playAudio();
						} else if (count > 0) {
							this.toastr.error(
								`Foram recebidas ${count} novas emergências!`,
								'',
								{
									timeOut: 7000,
								}
							);
							this.playAudio();
						}

						emergencies = complaints;
					});
				}
			}, 30000);
		});
	}

	public customPost(
		url: string,
		body: FormData,
		fields: any,
		file: File
	): Observable<any> {
		for (const [key, value] of Object.entries(fields)) {
			body.append(String(key), String(value));
		}
		return this.http.post(url, body);
	}

	/**
	 * Creates a request for add media on complaint
	 * @param id request id
	 * @param fileName name of the file that will be uploaded
	 * @returns request to upload image
	 */
	public addMedia(id: string, filename): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/${id}/media/url/?filename=${filename}`;

		return this.http.get(url);
	}

	public fetchMediaUrl(id: string, origin: string): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/media?key=${id}&media_origin=${origin}`;

		const headers = new HttpHeaders({
			Authorization: `${localStorage.getItem('idToken')}`,
			'access-token': `${localStorage.getItem('accessToken')}`,
		});

		return this.http.get(url, { headers });
	}

	public getPartialComplaints(from: string): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));

		let url = environment.backend.complaintsURL;
		url = url + (superUser ? '/complaints/super/' : '/complaints/op/');

		url += '?paginate=f';

		url += `&modified_at_from=${from}`;

		return this.http.get(url);
	}

	/**
	 * Create the http request to get complaint summary
	 * @param id complaint ID
	 * @returns request Observable to summary id
	 */
	public getSummary(id: string): Observable<any> {
		const url = environment.backend.complaintsURL + `/complaints/${id}/summary`;

		return this.http.get(url);
	}

	/**
	 * Create a request for last complaints (7 days range)
	 * @returns Observable com as Complaints da semana
	 */
	public getWeekComplaints(): Observable<any> {
		const url = environment.backend.complaintsURL + '/complaints/op/week';

		return this.http.get(url);
	}

	public getDashboardCards(): Observable<any> {
		const url =
			environment.backend.complaintsURL + '/complaints/op/dashboard/cards';

		return this.http.get(url);
	}

	/**
	 * Create a request based on aggregation group
	 * @param group Group to aggregate
	 * @returns Observable
	 */
	public getAggregations(
		group: string,
		from?: string,
		to?: string
	): Observable<any> {
		let URL =
			environment.backend.complaintsURL +
			`/complaints/op/aggregate?group=${group}`;

		if (to && from) {
			URL = URL += `&from_date=${from}&to_date=${to}`;
		}

		return this.http.get(URL);
	}

	public getComplaints(query?: ComplaintsReq): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));

		let url: string = environment.backend.complaintsURL;
		url = url + (superUser ? '/complaints/super/' : '/complaints/op/');

		if (query?.paginate) {
			url += '?paginate=false';
		}

		if (query?.details) {
			url += '&week=true';
		}

		if (query?.bus_name) {
			if (query?.bus_name == 'Não identificado') {
				url += `&bus_name=untracked`;
			} else if (query?.bus_name != 'Todos') {
				url += `&bus_name=${query?.bus_name}`;
			}
		}

		// if (query.occurence != 'Todas' && query.occurence) {
		// 	url += `&occurence=${query.occurence}`;
		// }

		if (query?.gender && query?.gender != 'Todos') {
			url += `&genders=${query?.gender}`;
		}

		if (query?.type) {
			url += `&complaint_type=${query?.type}`;
		}

		if (query?.occurence_date) {
			url += `&occurence_date=${query?.occurence_date}`;
		}

		if (
			query?.sublocality_complaint != 'Todos' &&
			query?.sublocality_complaint
		) {
			url += `&sublocality=${query?.sublocality_complaint}`;
		}

		if (query?.user_id_complaint != 'Todos' && query?.user_id_complaint) {
			url += `&user_id=${query?.user_id_complaint}`;
		}

		if (
			query?.created_at_from_date_complaint != 'Todos' &&
			query?.created_at_from_date_complaint
		) {
			url += `&created_at_from=${query?.created_at_from_date_complaint}`;
		}

		if (
			query?.created_at_to_date_complaint != 'Todos' &&
			query?.created_at_to_date_complaint
		) {
			url += `&created_at_to=${query?.created_at_to_date_complaint}`;
		}

		if (query?.place_complaint != 'Todos' && query?.place_complaint) {
			url += `&place=${query?.place_complaint}`;
		}

		if (query?.atMoment) {
			url += `&at_moment=true`;
		}

		if (query?.age && query.age != 'Todos') {
			url += `&age_group=${query?.age}`;
		}

		if (query?.orderBy) {
			url += `&sort=${query?.orderBy[0]}&flow=${query?.orderBy[1]}`;
		}

		return this.http.get(url);
	}

	public getEmergencies(
		status: string = 'ALL',
		current: boolean = false
	): Observable<any> {
		let url: string =
			environment.backend.complaintsURL + '/complaints/op/emergency';

		url += `?status_filter=${status}`;

		if (current) {
			url += `&default_time_interval=last_15_minutes`;
		}

		return this.http.get(url);
	}

	public getEmergenciesStaticData(): Observable<any> {
		let url: string =
			environment.backend.complaintsURL + '/complaints/op/emergency/static';

		const headers = new HttpHeaders({
			Authorization: `${localStorage.getItem('idToken')}`,
			'access-token': `${localStorage.getItem('accessToken')}`,
		});

		return this.http.get(url, { headers });
	}

	public getCsv(event_log: boolean = false): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/csv?event_log=${event_log}`;

		return this.http.get(url);
	}

	public getComplaintsDashboard(query?: DashboardReq): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));

		let url: string = environment.backend.complaintsURL;
		url = url + '/complaints/op/dashboard?';

		if (query?.bus_name) {
			if (query?.bus_name == 'Não identificado') {
				url += `&bus_name=untracked`;
			} else if (query?.bus_name != 'Todos') {
				url += `&bus_name=${query?.bus_name}`;
			}
		}

		url += `&frequent_terms_limit=25`;

		if (query?.occurence != 'Todos' && query?.occurence) {
			url += `&occurence=${query?.occurence}`;
		}

		if (query?.gender && query.gender != 'Todos') {
			url += `&genders=${query.gender}`;
		}

		if (query?.type) {
			url += `&complaint_type=${query?.type}`;
		}

		if (
			query?.sublocality_complaint != 'Todos' &&
			query?.sublocality_complaint
		) {
			url += `&sublocality=${query?.sublocality_complaint}`;
		}

		if (query?.age && query.age != 'Todos') {
			url += `&age_group=${query?.age}`;
		}

		if (query?.user_id_complaint != 'Todos' && query?.user_id_complaint) {
			url += `&user_id=${query?.user_id_complaint}`;
		}

		if (
			query?.created_at_from_date_complaint != 'Todos' &&
			query?.created_at_from_date_complaint
		) {
			url += `&from_date=${query?.created_at_from_date_complaint}`;
		}

		if (
			query?.created_at_to_date_complaint != 'Todos' &&
			query?.created_at_to_date_complaint
		) {
			url += `&to_date=${query?.created_at_to_date_complaint}`;
		}

		if (query?.place_complaint != 'Todos' && query?.place_complaint) {
			url += `&place=${query?.place_complaint}`;
		}

		return this.http.get(url);
	}

	public getComplaintsPerPeriod(from: string, to: string): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			'/complaints/op/period' +
			`?from_date=${from}&to_date=${to}`;

		return this.http.get(url);
	}

	public getComplaintsRecurrent(
		bus_name: string = null,
		occurence: string = null,
		occurence_date: string = null,
		place_complaint: string = null,
		sublocality_complaint: string = null,
		user_id_complaint: string = null,
		created_at_from_date_complaint: any = null,
		created_at_to_date_complaint: any = null
	): Observable<any> {
		let url =
			environment.backend.complaintsURL + '/complaints/op/recurrent-users?';

		if (bus_name) {
			if (bus_name == 'Não identificado') {
				url += `&bus_name=untracked`;
			} else if (bus_name != 'Todos') {
				url += `&bus_name=${bus_name}`;
			}
		}

		if (occurence != 'Todas' && occurence) {
			url += `&occurence=${occurence}`;
		}

		if (occurence_date) {
			url += `&occurence_date=${occurence_date}`;
		}

		if (sublocality_complaint != 'Todos' && sublocality_complaint) {
			url += `&sublocality=${sublocality_complaint}`;
		}

		if (user_id_complaint != 'Todos' && user_id_complaint) {
			url += `&user_id=${user_id_complaint}`;
		}

		if (
			created_at_from_date_complaint != 'Todos' &&
			created_at_from_date_complaint
		) {
			url += `&created_at_from=${created_at_from_date_complaint}`;
		}

		if (
			created_at_to_date_complaint != 'Todos' &&
			created_at_to_date_complaint
		) {
			url += `&created_at_to=${created_at_to_date_complaint}`;
		}

		if (place_complaint != 'Todos' && place_complaint) {
			url += `&place=${place_complaint}`;
		}

		return this.http.get(url);
	}

	putStatusDenounce(status: any, id: string): Observable<any> {
		function translateStatus(string: string) {
			if (string == 'Relato recebido') return 'MAIN_STATUS_REGISTERED';
			if (string == 'Em análise') return 'MAIN_STATUS_UNDER_ANALYSIS';
			if (string == 'Análise concluída') return 'MAIN_STATUS_CONCLUDED';
		}

		const url = environment.backend.complaintsURL + `/complaints/op/status`;
		let statusObjeto = Object.assign(
			{},
			{ ...status, main: translateStatus(status.main) }
		);
		delete statusObjeto.name;
		return this.http.put(url, { _id: id, status: statusObjeto });
	}

	/**
	 * Creates a request for complaints list by harassment type
	 * @param type harassment type
	 * @returns Observable
	 */
	public getComplaintsType(type?: string): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));
		let url = environment.backend.complaintsURL;

		url = superUser
			? `/complaints/super/?type=${type}&paginate=0`
			: `/complaints/op/?type=${type}&paginate=0`;

		return this.http.get(url);
	}

	/**
	 * Creates a request for delete an image
	 * @param filePath image URL
	 * @param id complaint ID
	 * @returns Observable
	 */
	public deleteImgComplaints(filePath: string, id: string): Observable<any> {
		const url = `${environment.backend.complaintsURL}/complaints/${id}/media?key=${filePath}`;

		return this.http.delete(url);
	}

	public deleteOpMedia(filePath: string, id: string): Observable<any> {
		const url = `${environment.backend.complaintsURL}/complaints/op/${id}/media?key=${filePath}`;

		return this.http.delete(url);
	}

	public deleteUserMedia(filePath: string, id: string): Observable<any> {
		const url = `${environment.backend.complaintsURL}/complaints/${id}/media/${filePath}`;

		return this.http.delete(url);
	}

	/**
	 * Creates a request to get complaints per type
	 * @param type harassment type
	 * @param from begin date
	 * @param to final date
	 * @returns Observable to the request
	 */
	public getComplaintsPeT(
		type?: string,
		from?: string,
		to?: string
	): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));
		let url = environment.backend.complaintsURL;

		url =
			url + superUser
				? `/complaints/super/?type=${type}&&from_date=${from}&&to_date=${to}&paginate=0`
				: `/complaints/op/?type=${type}&&from_date=${from}&&to_date=${to}&paginate=0`;

		return this.http.get(url);
	}

	/**
	 * Create a request for edit a complaint
	 * @param data Informação a ser editada da complaint + ID
	 * @returns Observable para a edição da complaint
	 */
	public editComplaint(data: Partial<Denounce>): Observable<Denounce> {
		const url = environment.backend.complaintsURL + '/complaints';

		return this.http.put<Denounce>(url, data);
	}

	/**
	 * Create a request for an especific complaint
	 * @param id complaint id
	 * @returns Observable for that request
	 */
	public getDenounce(id: string): Observable<Denounce> {
		const url = environment.backend.complaintsURL + '/complaints/' + id;

		return this.http.get<Denounce>(url);
	}

	public getBusLines(): Observable<any> {
		const url = environment.backend.complaintsURL + '/complaints/op/bus-lines';

		return this.http.get(url);
	}

	public deleteComplaint(id: string): Observable<Denounce> {
		const url = environment.backend.complaintsURL + '/complaints/' + id;

		return this.http.delete<Denounce>(url);
	}

	public commentComplaint(
		complaint_id: string,
		body_comment: string
	): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/${complaint_id}/comment/?body_comment=${body_comment}`;

		return this.http.get(url);
	}

	public delcommentComplaint(
		complaint_id: string,
		datetime: any
	): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/${complaint_id}/comment/?comment_datetime=${datetime}`;

		return this.http.delete(url);
	}

	public complaintsByBusLine(bus_name: string): Observable<any> {
		const url =
			environment.backend.complaintsURL +
			`/complaints/op/get_complaints_by_bus_name/?bus_name=${bus_name} `;

		return this.http.get(url);
	}
}
